export const MARK_TASK_IMPLEMENTED = `
  mutation MarkTaskImplemented($input: MarkTaskImplementedInput!) {
    markTaskImplemented(input: $input) {
      taskId
      status
      implementedAt
      implementedBy
      developerHandoff
    }
  }
`
